export default "__VITE_ASSET__eZmYx9pb__"